import {
    createMuiTheme,
    FormHelperText,
    Grid,
    makeStyles,
    MuiThemeProvider,
} from '@material-ui/core';
import React, { useRef } from 'react';
import ReactQuill from 'react-quill';

const useStyles = makeStyles((theme) => ({
    label: {
        color: '#F47B15',
    },
    asterisk: {
        color: '#FF0000',
    },
    qlEditor: {
        '& .ql-editor': {
            fontSize: '20px !important',
            fontFamily: 'DB_Ozone !important',
        },
        '& .ql-editor::before': {
            color: '#BCBCBC !important',
            fontFamily: 'DB_Ozone !important',
            fontStyle: 'normal',
        },
    },
    formHelper: {
        color: theme.mainTheme.color5,
        marginTop: '1px',
        marginLeft: '10px',
    },
    colorErr: {
        color: theme.mainTheme.color5,
    },
    qlEditorError: {
        '& .ql-editor': {
            fontSize: '20px !important',
            fontFamily: 'DB_Ozone !important',
        },
        '& .ql-editor::before': {
            color: '#BCBCBC !important',
            fontFamily: 'DB_Ozone !important',
            fontStyle: 'normal',
        },
        '& .ql-toolbar': {
            borderColor: theme.mainTheme.color5,
        },
        '& .ql-container': {
            borderColor: theme.mainTheme.color5,
        },
    },
}));

const materialTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#F47B15', //main color
            dark: '#F47B15', //hover
            contrastText: '#ffffff', //text color
        },
    },
    typography: {
        fontSize: 20,
        fontFamily: `DB_Ozone !important`,
    },
});

const QuillEditorField = ({
    input,
    meta: { touched, error, invalid },
    label,
    required,
    placeholder,
    maxLength,
}) => {
    const classes = useStyles();
    const asterisk = required ? (
        <span className={classes.asterisk}> *</span>
    ) : (
        ''
    );
    const quillRef = useRef(null);
    const handleChange = (value) => {
        if (maxLength) {
            const doc = new DOMParser().parseFromString(value, 'text/html');
            const textContent = doc.body.textContent;
            if (textContent.length <= maxLength) {
                input.onChange(value);
            } else {
                const quill = quillRef.current.getEditor();
                const quillLength = quill.getLength();
                const excess = textContent.length - maxLength;

                const selection = quill.getSelection();
                const currIndex =
                    selection && selection.index !== null
                        ? selection.index
                        : quillLength - 1;
                const start = currIndex - excess;
                if (start >= 0) {
                    quill.deleteText(start, excess);
                }
            }
        } else {
            input.onChange(value);
        }
    };
    return (
        <Grid container>
            <Grid item xs={12}>
                <label
                    className={
                        touched && invalid ? classes.colorErr : classes.label
                    }
                >
                    {label}
                    <span className={classes.asterisk}>{asterisk}</span>
                </label>
            </Grid>
            <Grid item xs={12} className={classes.editorContainer}>
                <MuiThemeProvider theme={materialTheme}>
                    <ReactQuill
                        {...input}
                        ref={quillRef}
                        onChange={handleChange}
                        onBlur={() => input.onBlur(input.value)}
                        placeholder={placeholder}
                        className={
                            touched && invalid
                                ? classes.qlEditorError
                                : classes.qlEditor
                        }
                        modules={{
                            toolbar: [
                                ['bold', 'italic', 'underline'],
                                ['link'],
                            ],
                        }}
                    ></ReactQuill>
                </MuiThemeProvider>
            </Grid>
            {touched && error && (
                <FormHelperText className={classes.formHelper}>
                    {error}
                </FormHelperText>
            )}
        </Grid>
    );
};

export default QuillEditorField;
